import { AdaptiveFilterButtons } from '@/features/adaptiveFilterButtons/AdaptiveFilterButtons'
import { FilterButtonModel } from '@/shared/components/MobileFilterButtons/MobileFilterButtons'
import { SearchInput } from '@/shared/components/SearchInput/SearchInput'
import { useIsMobile } from '@/shared/utils'

type Props = {
  selectedIndex: number
  selectFilterBtn: (index: number) => void
  setSearch: (value: string) => void
}

export const OrdersInputsBlock = ({ setSearch, selectFilterBtn, selectedIndex }: Props) => {
  const isMobile = useIsMobile()
  const filterButtons: FilterButtonModel[] = [
    { name: 'Все', label: 'all', index: 0 },
    { name: isMobile ? 'Ожидают' : 'Ожидают принятия', label: 'new', index: 1 },
    { name: 'Активные ', label: 'inProgress', index: 2 },
    { name: 'Принятые', label: 'done', index: 3 },
    { name: 'Отклонены', label: 'canceled', index: 4 },
  ]

  return (
    <div className="flex justify-between items-center gap-2 mb-[30px] md:mb-[22px]">
      <div className="flex flex-1 items-center gap-2 md:gap-6">
        <AdaptiveFilterButtons
          selectedBtn={selectedIndex}
          setSelectedBtn={selectFilterBtn}
          filterButtons={filterButtons}
          minWidthMobile="150px"
        />
      </div>
      <SearchInput
        onChange={(event) => {
          const numericOnly = event.target.value.replace(/\D/g, '')
          setSearch(numericOnly)
        }}
        placeholder="Поиск"
        className="flex-1"
        minWidth="150px"
      />
    </div>
  )
}
